import React from "react";

const ITEMS = [
  {
    id: "ivory-residence",
    title: "Ivory Apartment",
    place: "Vidyanagar, Hubballi",
    tag: "3BHK · Turnkey",
    img: "https://images.pexels.com/photos/6585627/pexels-photo-6585627.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    id: "walnut-kitchen",
    title: "Compact Modular Kitchen",
    place: "Gokul Road, Hubballi",
    tag: "2BHK Kitchen",
    img: "https://images.pexels.com/photos/1599791/pexels-photo-1599791.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "md:col-span-5",
  },
  {
    id: "smoked-wardrobe",
    title: "Bedroom & Wardrobe",
    place: "Keshwapur, Hubballi",
    tag: "Bedroom · Wardrobe",
    img: "https://images.pexels.com/photos/6480198/pexels-photo-6480198.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "md:col-span-5",
  },
  {
    id: "linen-apartment",
    title: "Studio Apartment",
    place: "Navanagar, Hubballi",
    tag: "1BHK · Renovation",
    img: "https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "md:col-span-6",
  },
  {
    id: "espresso-loft",
    title: "Family Living Room",
    place: "Saptapur, Dharwad",
    tag: "Living · Dining",
    img: "https://images.pexels.com/photos/6585766/pexels-photo-6585766.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "md:col-span-6",
  },
];

const Portfolio = () => (
  <section
    id="portfolio"
    className="relative bg-[#1A1512] text-[#F7F5F0]"
    data-testid="portfolio-section"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-32">
      <div className="grid items-end gap-6 md:grid-cols-12">
        <div className="md:col-span-8">
          <span className="text-[10px] uppercase tracking-[0.32em] text-[#B8996F]">04 · Portfolio</span>
          <h2 className="mt-4 font-[Cormorant_Garamond] text-4xl font-light leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            Real homes,<br /> <span className="italic text-[#B8996F]">practical</span> craft.
          </h2>
        </div>
        <div className="md:col-span-4">
          <p className="font-[Outfit] text-base leading-relaxed text-white/65">
            Compact 2BHKs, family living rooms and modular kitchens across
            Hubballi and Dharwad — designed for everyday Indian apartments,
            not magazine sets.
          </p>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12 md:auto-rows-[260px] md:gap-8">
        {ITEMS.map((p) => (
          <a
            key={p.id}
            href="#contact"
            data-testid={`portfolio-card-${p.id}`}
            className={`group relative block overflow-hidden border border-white/10 bg-[#0F0D0B] ${p.span}`}
          >
            <img
              src={p.img}
              alt={p.title}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
            <div className="relative flex h-full flex-col justify-between p-6 md:p-8">
              <span className="self-start bg-[#B8996F] px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-[#0A0A0A]">
                {p.tag}
              </span>
              <div>
                <div className="font-[Cormorant_Garamond] text-3xl font-light leading-tight">{p.title}</div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.24em] text-white/70">{p.place}</div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Portfolio;
